import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"
import { GeneralSettingsContext } from "src/main/Settings/General"

import Form from "src/components/Form"
import HeadingPageTitle from "src/components/Heading/HeadingPageTitle"

const InsuranceAndRegistration = () => {
  const { register } = useFormContext()
  const { canUpdateSettings, insuranceAndRegistrationOptions } = useContext(
    GeneralSettingsContext
  )

  const renderSettingSelect = (label, fieldName) => {
    return (
      <div className="max-w-[600px]">
        <Form.Label htmlFor={fieldName}>{label}</Form.Label>
        <Form.Select
          id={fieldName}
          {...register(fieldName)}
          disabled={!canUpdateSettings}
        >
          {Object.entries(insuranceAndRegistrationOptions).map((option) => (
            <option key={option[0]} value={option[0]}>
              {option[1]}
            </option>
          ))}
        </Form.Select>
      </div>
    )
  }

  return (
    <div className="form-group flex flex-col space-y-4">
      <HeadingPageTitle>Insurance & Registration</HeadingPageTitle>
      <div>
        <p className="mb-1">
          Default settings for requiring registration and insurance info on new
          contract groups and general leads.
        </p>
        <p className="text-muted m-0">
          Note: Document Upload only applies to Contracts; document uploads are
          not offered for leads.
        </p>
      </div>
      {renderSettingSelect(
        "Registration Requirement (registration number & expiration date)",
        "registration_requirement_for_contracts"
      )}
      {renderSettingSelect(
        "Insurance Requirement (company name, policy number & expiration date)",
        "insurance_requirement_for_contracts"
      )}
    </div>
  )
}

export default InsuranceAndRegistration
